import {
	checkpaypassword,
	payment,
	calculate,
	orderCreate,
	balanceConfig
} from "@/api/order/payment"
import {
	addressList,
	saveAddress,
	setDefault,
	deleteAddress,
	addressInfo
} from "@/api/member/member"
import {
	getArea
} from "@/api/address"
import {
	mapGetters
} from "vuex"

export default {
	name: "payment",
	components: {},
	data: () => {
		var checkMobile = (rule, value, callback) => {
			if (value === "") {
				callback(new Error("กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ"))
			} else if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(value)) {
				callback(new Error("หมายเลขโทรศัพท์อยู่ในรูปแบบที่ไม่ถูกต้อง"))
			} else {
				callback()
			}
		}

		return {
			dialogVisible: false,
			memberAddress: [], //รายการที่อยู่สําหรับจัดส่ง
			addressId: 0, //ที่อยู่จัดส่ง
			addressForm: {
				id: 0,
				name: "",
				mobile: "",
				telephone: "",
				province_id: "",
				city_id: "",
				district_id: "",
				community_id: "",
				address: "",
				full_address: "",
				is_default: "",
				longitude: "",
				latitude: ""
			},
			pickerValueArray: {},
			cityArr: {},
			districtArr: {},
			addressRules: {
				name: [{
						required: true,
						message: "กรุณาใส่ผู้รับสินค้า",
						trigger: "blur"
					},
					{
						min: 1,
						max: 20,
						message: "ความยาวอยู่ใน 1 ถึง 20 อักขระ",
						trigger: "blur"
					}
				],
				mobile: [{
					required: true,
					validator: checkMobile,
					trigger: "change"
				}],
				province: [{
					required: true,
					message: "โปรดเลือกจังหวัด",
					trigger: "change"
				}],
				city: [{
					required: true,
					message: "โปรดเลือกเมือง",
					trigger: "change"
				}],
				district: [{
					required: true,
					message: "โปรดเลือกโซน/เขต",
					trigger: "change"
				}],
				address: [{
					required: true,
					message: "กรุณากรอกที่อยู่แบบเต็มของคุณ",
					trigger: "change"
				}]
			},
			isSend: false,
			orderCreateData: {
				is_balance: 0,
				is_point: 1,
				pay_password: '',

				// ใบส่งของ
				is_invoice: 0, // จําเป็นต้องมีใบแจ้งหนี้หรือไม่ 0 ไม่มีใบแจ้งหนี้  1 มีใบแจ้งหนี้
				invoice_type: 1, // ประเภทใบแจ้งหนี้  1 กระดาษ 2 อิเล็กตรอน
				invoice_title_type: 1, // ประเภทเฮดอัพ  1 บุคคล 2 กิจการ
				is_tax_invoice: 0, // จําเป็นต้องมีใบกํากับภาษี VAT พิเศษหรือไม่  0 ไม่จําเป็นต้องใช้ 1 ต้องการ
				invoice_title: '', // ชื่อใบแจ้งหนี้
				taxpayer_number: '', // หมายเลขประจําตัวผู้เสียภาษีอากร
				invoice_content: '', // เนื้อหาใบแจ้งหนี้
				invoice_full_address: '', // ที่อยู่ทางไปรษณีย์ของใบแจ้งหนี้
				invoice_email: '', //กล่องจดหมายใบแจ้งหนี้
				member_address: {
					mobile: ''
				},
				is_open_card: 0,
				member_card_unit: ''
			},
			orderPaymentData: {
				shop_goods_list: {
					site_name: '',
					express_type: [],
					coupon_list: [],
					invoice: {
						invoice_content_array: []
					}
				},
				member_account: {
					balance: 0,
					is_pay_password: 0
				},
				delivery: {
					delivery_type: ''
				},
				member_address: {
					mobile: ''
				},
				local_config: {
					info: {
						start_time: 0,
						end_time: 0,
						time_week: []
					}
				}
			},
			dialogCoupon: false,
			siteCoupon: {
				site_id: 0,
				data: []
			},
			siteDelivery: {
				site_id: 0,
				data: []
			},
			dialogStore: false,
			promotionInfo: false,
			storeList: {},
			sitePromotion: [],
			isSub: false,
			dialogpay: false,
			password: "",
			fullscreenLoading: true,
			deliveryTime: false,
			timeTip: "เลือกเวลาจัดส่ง",
			time: null,
			addressShow: false,
			couponRadio: 0,
			storeRadio: 0,
			dialogPlatcoupon: false,
			platformCouponRadio: 0,
			// ข้อมูลร้านค้า
			storeInfo: {
				storeList: [], //ข้อมูลผลิตภัณฑ์ใน Store
				currStore: {} //ร้านค้าถูกเลือกในขณะนี้
			},
			// ที่อยู่รับสินค้า
			member_address: {
				mobile: ''
			},
			// เวลาปัจจุบัน
			timeInfo: {
				week: 0,
				start_time: 0,
				end_time: 0,
				showTime: false,
				showTimeBar: false
			},
			balance_show : 1,
			addresNextType : true
		}
	},
	computed: {
		...mapGetters(["orderCreateGoodsData", "defaultGoodsImage", "city"])
	},
	mounted() {},
	created() {
		this.getMemberAddress()
		this.getOrderPaymentData()
		this.getBalanceConfig()
	},

	filters: {
		/**
		 * จํานวนเอาต์พุตที่จัดรูปแบบ
		 * @param {Object} money
		 */
		moneyFormat(money) {
			return parseFloat(money).toFixed(2)
		},
		/**
		 * เลือกรับส่วนลดจากร้านค้า
		 */
		promotion(data) {
			let promotion = ""
			if (data) {
				Object.keys(data).forEach(key => {
					promotion += data[key].content + "　"
				})
			}
			return promotion
		}
	},
	methods: {
		//รับการกําหนดค่าการชําระเงินยอดคงเหลือ
		getBalanceConfig() {
			balanceConfig()
			.then(res => {
				const {
					code,
					message,
					data
				} = res
			
				if (code >= 0) {
					this.balance_show = data.balance_show;
				}
			})
			.catch(err => {
				const {
					code,
					message,
					data
				} = err
				// this.$notify.error({title: 'Error',message: message});
			})
		},
		//รับที่อยู่จัดส่ง
		getMemberAddress() {
			addressList({
					page_size: 0
				})
				.then(res => {
					const {
						code,
						message,
						data
					} = res
					if (data && data.list) {
						let that = this
						this.memberAddress = data.list
						data.list.forEach(function(e) {
							if (e.is_default == 1) {
								that.addressId = e.id
							}
						})
					}
				})
				.catch(err => {
					const {
						code,
						message,
						data
					} = err
					this.$notify.error({title: 'Error',message: message});
				})
		},

		//ตั้งค่าที่อยู่สําหรับจัดส่งของสมาชิก
		setMemberAddress(params) {
			this.addressId = params
			setDefault({
					id: params
				})
				.then(res => {
					const {
						code,
						message,
						data
					} = res
					this.orderCalculate()
				})
				.catch(err => {
					const {
						code,
						message,
						data
					} = err
					this.$notify.error({title: 'Error',message: message});
				})
		},

		//ลบที่อยู่สําหรับจัดส่งของสมาชิก
		deleteMemberAddress(params) {
			deleteAddress({
					id: params
				})
				.then(res => {
					const {
						code,
						message,
						data
					} = res
					if (data) {
						this.$notify({
							message: message,
							title: 'เรียบร้อยแล้ว',type: "success"
						})
						this.getMemberAddress()
					} else {
						this.$notify({
							message: message,
							title: "คำเตือน",type: "warning"
						})
					}
				})
				.catch(err => {
					this.$notify.error({title: 'Error',message: err.message});
				})
		},

		//เปิดเลเยอร์ป๊อปอัปเพิ่มที่อยู่สําหรับจัดส่ง
		addAddressShow() {
			this.dialogVisible = true
			this.addressForm.id = 0
			this.addressForm.name = ""
			this.addressForm.mobile = ""
			this.addressForm.telephone = ""
			this.addressForm.province_id = ""
			this.addressForm.city_id = ""
			this.addressForm.district_id = ""
			this.addressForm.community_id = ""
			this.addressForm.address = ""
			this.addressForm.full_address = ""
			this.addressForm.is_default = ""
			this.addressForm.longitude = ""
			this.addressForm.latitude = ""
			// this.$nextTick(() => {
			// 	this.$refs.form.resetFields();
			// });
			this.cityArr = {}
			this.districtArr = {}
			this.getAddress(0)
		},

		//รับที่อยู่
		getAddress(type) {
			let pid = 0
			let that = this
			switch (type) {
				case 0:
					//โหลดจังหวัด
					pid = 0
					break
				case 1:
					//โหลดเมือง
					pid = this.addressForm.province_id
					that.cityArr = {}
					that.districtArr = {}
					this.addressForm.city_id = ""
					this.addressForm.district_id = ""
					break
				case 2:
					//โหลดเขต
					pid = this.addressForm.city_id
					that.districtArr = {}
					this.addressForm.district_id = ""
					break
			}

			getArea({
					pid: pid
				})
				.then(res => {
					const {
						code,
						message,
						data
					} = res
					if (data) {
						
						switch (type) {
							case 0:
								that.pickerValueArray = data
								break
							case 1:
								//โหลดเมือง
								that.cityArr = data
								break
							case 2:
								//โหลดเขต
								that.districtArr = data
								break
						}
					}
					if(data.length == 0){
						this.addresNextType = false;
					}
				})
				.catch(err => {
					const {
						code,
						message,
						data
					} = err
					this.$notify.error({title: 'Error',message: message});
				})
		},

		//แก้ไขที่อยู่ เริ่ม ต้น
		initAddress(type) {
			let pid = 0
			let that = this
			switch (type) {
				case 0:
					//โหลดจังหวัด
					pid = 0
					break
				case 1:
					//โหลดเมือง
					pid = this.addressForm.province_id
					that.cityArr = {}
					that.districtArr = {}
					break
				case 2:
					//โหลดเขต
					pid = this.addressForm.city_id
					that.districtArr = {}
					break
			}

			getArea({
					pid: pid
				})
				.then(res => {
					const {
						code,
						message,
						data
					} = res
					if (data) {
						switch (type) {
							case 0:
								that.pickerValueArray = data
								break
							case 1:
								//โหลดเมือง
								that.cityArr = data
								break
							case 2:
								//โหลดเขต
								that.districtArr = data
								break
						}
					}
					if(data.length == 0){
						this.addresNextType = false;
					}
				})
				.catch(err => {
					const {
						code,
						message,
						data
					} = err
					this.$notify.error({title: 'Error',message: message});
				})
		},

		//ใหม่/แก้ไขที่อยู่สําหรับจัดส่ง
		addmemberAddress(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.isSend) {
						return false
					}

					if (!this.addressForm.id) {
						this.addressForm.full_address = this.$refs.province.selectedLabel + "-" + this.$refs.city.selectedLabel + "-" +
							this.$refs.district.selectedLabel
						let data = {
							name: this.addressForm.name,
							mobile: this.addressForm.mobile,
							telephone: this.addressForm.telephone,
							province_id: this.addressForm.province_id,
							city_id: this.addressForm.city_id,
							district_id: this.addressForm.district_id,
							community_id: "",
							address: this.addressForm.address,
							full_address: this.addressForm.full_address,
							longitude: this.addressForm.longitude,
							latitude: this.addressForm.latitude,
							is_default: this.addressForm.is_default,
							url: 'add'
						}

						if (!data.province_id || data.province_id <= 0 ) {
							this.$notify({
								message: "กรุณาเลือกจังหวัดให้ถูกต้อง",
								title: "คำเตือน",type: "warning"
							})
							return false
						}
						if (!data.city_id || data.city_id <= 0) {
							this.$notify({
								message: "โปรดเลือกเมืองให้ถูกต้อง",
								title: "คำเตือน",type: "warning"
							})
							return false
						}
						if ((!data.district_id || data.district_id <= 0 ) && this.addresNextType == true) {
							this.$notify({
								message: "กรุณาเลือกโซนให้ถูกต้อง/เขต",
								title: "คำเตือน",type: "warning"
							})
							return false
						}
						this.isSend = true

						saveAddress(data)
							.then(res => {
								const {
									code,
									message,
									data
								} = res
								if (data) {
									this.setMemberAddress(data)

									this.$notify({
										message: message,
										title: 'เรียบร้อยแล้ว',type: "success"
									})
									this.dialogVisible = false
									this.getMemberAddress()
									this.getOrderPaymentData()
								} else {
									this.$notify({
										message: message,
										title: "คำเตือน",type: "warning"
									})
								}
								this.isSend = false
							})
							.catch(err => {
								const {
									code,
									message,
									data
								} = err
								this.$notify.error({title: 'Error',message: message});
							})
					} else {
						this.addressForm.full_address = this.$refs.province.selectedLabel + "-" + this.$refs.city.selectedLabel + "-" +
							this.$refs.district.selectedLabel
						let data = this.addressForm
						if (!data.province_id) {
							this.$notify({
								message: "โปรดเลือกจังหวัด",
								title: "คำเตือน",type: "warning"
							})
							return false
						}
						if (!data.city_id) {
							this.$notify({
								message: "โปรดเลือกเมือง",
								title: "คำเตือน",type: "warning"
							})
							return false
						}
						if (!data.district_id) {
							this.$notify({
								message: "โปรดเลือกโซน/เขต",
								title: "คำเตือน",type: "warning"
							})
							return false
						}
						this.isSend = true
						this.setMemberAddress(data.id);
						data.url = "edit";
						saveAddress(data)
							.then(res => {
								const {
									code,
									message,
									data
								} = res
								if (data) {
									this.$notify({
										message: message,
										title: 'เรียบร้อยแล้ว',type: "success"
									})
									this.dialogVisible = false
									this.getMemberAddress()
									this.getOrderPaymentData()
								} else {
									this.$notify({
										message: message,
										title: "คำเตือน",type: "warning"
									})
								}
								this.isSend = false
							})
							.catch(err => {
								const {
									code,
									message,
									data
								} = err
								this.$notify.error({title: 'Error',message: message});
							})
					}
				} else {
					return false
				}
			})
		},

		//แก้ไขที่อยู่สําหรับจัดส่ง
		editAddress(id) {
			addressInfo({
					id: id
				})
				.then(res => {
					const {
						code,
						message,
						data
					} = res
					this.addressForm = {
						id: data.id,
						name: data.name,
						mobile: data.mobile,
						telephone: data.telephone,
						province_id: data.province_id,
						city_id: "",
						district_id: "",
						community_id: "",
						address: data.address,
						full_address: data.full_address,
						is_default: data.is_default,
						longitude: data.longitude,
						latitude: data.latitude
					}
					this.initAddress(0)
					this.initAddress(1)
					this.addressForm.city_id = data.city_id
					this.initAddress(2)
					this.addressForm.district_id = data.district_id

					this.dialogVisible = true
				})
				.catch(err => {
					const {
						code,
						message,
						data
					} = err
					this.$notify.error({title: 'Error',message: message});
				})
		},

		/**
		 * รับข้อมูลการเริ่มต้นคําสั่งซื้อ
		 */
		getOrderPaymentData() {
			this.orderCreateData = this.orderCreateGoodsData
			if (!this.orderCreateData) {
				this.$notify({
					message: "ไม่ได้รับข้อมูลที่จําเป็นในการสร้างคําสั่งซื้อ！", //ข้อมูลที่ได้รับแจ้ง
					title: "คำเตือน",type: "warning",
					offset: 225,
					duration: 3000,
					onClose: () => {
						this.$router.go(-1)
						return false
					}
				})
				return
			}





			this.orderCreateData.web_city = this.city ? this.city.id : 0
			payment(this.orderCreateData)
				.then(res => {
					const {
						code,
						message,
						data
					} = res

					if (code >= 0) {
						this.orderPaymentData = data
						this.handlePaymentData()
					} else {
						this.$notify({
							message: "ไม่ได้รับข้อมูลที่จําเป็นในการสร้างคําสั่งซื้อ！", //ข้อมูลที่ได้รับแจ้ง
							title: "คำเตือน",type: "warning",
							offset: 225,
							duration: 3000,
							onClose: () => {
								this.$router.go(-1)
								return false
							}
						})
						return
					}
				})
				.catch(err => {
					const {
						code,
						message,
						data
					} = err
					// this.$notify.error({title: 'Error',message: message});
				})
		},
		/**
		 * ประมวลผลข้อมูลใบสั่งชําระเงิน
		 */
		handlePaymentData() {
			this.orderCreateData.delivery = {}
			this.orderCreateData.coupon = {}
			this.orderCreateData.buyer_message = ""
			this.orderCreateData.is_balance = 0
			this.orderCreateData.pay_password = ""
			this.orderCreateData.is_point = 1;
			
			this.orderCreateData.is_invoice = 0; // จําเป็นต้องมีใบแจ้งหนี้หรือไม่ 0 ไม่มีใบแจ้งหนี้  1 มีใบแจ้งหนี้
			this.orderCreateData.invoice_type = 1; // ประเภทใบแจ้งหนี้  1 กระดาษ 2 อิเล็กตรอน
			this.orderCreateData.invoice_title_type = 1; // ชนิดส่วนหัวของใบแจ้งหนี้ 1 บุคคล 2กิจการ
			this.orderCreateData.is_tax_invoice = 0; // จําเป็นต้องมีใบกํากับภาษี VAT พิเศษหรือไม่  0 ไม่จําเป็นต้องใช้ 1 ต้องการ
			this.orderCreateData.invoice_title = '';
			
			var data = this.orderPaymentData
			if (data.recommend_member_card) {
				this.orderCreateData.member_card_unit = Object.keys(data.recommend_member_card.charge_rule)[0];
			}
			// การปฏิบัติตามร้านค้า
			if (data.shop_goods_list.express_type.length > 1) {
				console.log(data.shop_goods_list.express_type, 'วิธีการจัดส่ง')
				this.orderCreateData.delivery_type = 'express'
				this.orderCreateData.delivery_type_name = 'การจัดส่งโลจิสติกส์'
			}
			// คูปองร้านค้า
			if (data.shop_goods_list.coupon_list != undefined && data.shop_goods_list.coupon_list[0] != undefined) {
				var coupon_list = data.shop_goods_list.coupon_list;
				this.orderCreateData.coupon.coupon_id = coupon_list[0].coupon_id;
				this.orderCreateData.coupon.coupon_money = coupon_list[0].money;
			}

			// ลบเต็ม
			if (data.shop_goods_list.promotion != undefined && data.shop_goods_list.promotion.manjian != undefined) {
				this.manjian = data.shop_goods_list.promotion.manjian;
			}

			if (this.orderPaymentData.is_virtual) this.orderCreateData.member_address = {
				mobile: ''
			};

			if (this.orderPaymentData.shop_goods_list.invoice) {
				var invoice_content_array = this.orderPaymentData.shop_goods_list.invoice.invoice_content_array;
				if (invoice_content_array.length) this.orderCreateData.invoice_content = invoice_content_array[0];
			}

			if (this.orderPaymentData.is_virtual == 0) {

				// จะแสดงการเลือกเวลาหรือไม่
				if (this.orderPaymentData.shop_goods_list.local_config.info && this.orderPaymentData
					.shop_goods_list.local_config.info.time_is_open == 1) {
					this.timeInfo.showTimeBar = true;
					// รองรับการจัดส่งในวันเดียวกันหรือไม่
					if (this.orderPaymentData.shop_goods_list.local_config.info.time_week.length == 0 ||
						this.orderPaymentData.shop_goods_list.local_config.info.time_week.length == 7 ||
						this.orderPaymentData.shop_goods_list.local_config.info.time_week.indexOf(this.timeInfo.week) > -1) {
						this.canLocalDelicery = true;
					} else {
						this.canLocalDelicery = false;
					}

					if (this.orderPaymentData.shop_goods_list.local_config.info.time_type == 0) {
						this.deliveryWeek = "ตลอดวัน";
					} else if (this.orderPaymentData.shop_goods_list.local_config.info.time_week.length > 0) {

						if (this.orderPaymentData.shop_goods_list.local_config.info.time_week.length == 7) {
							this.deliveryWeek = "ตลอดวัน";
						} else {
							this.timeInfo.showTime = true;
							// ตรวจสอบว่าเวลาการส่งมอบต่อเนื่องหรือเป็นช่วงเวลา
							var timeWeek = this.orderPaymentData.shop_goods_list.local_config.info.time_week;
							var is_interval = false; // ไม่ว่าจะเว้นวรรค
							for (var i = 0; i < timeWeek.length; i++) {
								if ((i + 1) < timeWeek.length) {
									var difference = timeWeek[i + 1] - timeWeek[i];
									if (difference > 1) {
										is_interval = true;
										break;
									}
								}
							}

							var weeks = ['วันอาทิตย์', 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์'];
							if (is_interval) {
								var temp = [];
								for (var i = 0; i < timeWeek.length; i++) {
									temp.push(weeks[timeWeek[i]]);
								}
								this.deliveryWeek = temp.join("、");
							} else {
								this.deliveryWeek = weeks[timeWeek[0]] + "ถึง" + weeks[timeWeek[timeWeek.length - 1]];
							}
						}
					} else {
						this.deliveryWeek = "ร้านค้าไม่ได้กําหนดเวลาจัดส่ง";
					}

					// จะtimepickerเลือกเวลาปัจจุบัน
					var h = new Date().getHours().toString();
					var m = new Date().getMinutes().toString();
					if (h.length == 1) {
						h = '0' + h;
					}
					if (m.length == 1) {
						m = '0' + m;
					}

					this.orderCreateData.buyer_ask_delivery_time = h + ':' + m;

					// pickerเวลาเริ่มต้นของส่วนประกอบ
					let start_time = this.orderPaymentData.shop_goods_list.local_config.info.start_time;
					this.timeInfo.start_time = this.getTimeStr(start_time);

					let end_time = this.orderPaymentData.shop_goods_list.local_config.info.end_time;
					this.timeInfo.end_time = this.getTimeStr(end_time);

					var current_time = new Date(this.$util.timeStampTurnTime(this.orderPaymentData.timestamp));
					var hour = current_time.getHours();
					var minute = current_time.getMinutes();

					var start_hour = parseInt(this.timeInfo.start_time.split(":")[0]);
					var start_minute = parseInt(this.timeInfo.start_time.split(":")[1]);

					var end_hour = parseInt(this.timeInfo.end_time.split(":")[0]);
					var end_minute = parseInt(this.timeInfo.end_time.split(":")[1]);

					// ตรวจสอบว่าสามารถจัดส่งได้ในวันเดียวกันหรือไม่，จากนั้นตัดสินเวลาการส่งมอบ。ไม่สามารถสั่งซื้อได้ในวันที่จัดส่ง，ตัวอย่าง：เวลาจัดส่งคือวันจันทร์ถึงวันศุกร์，จากนั้นคุณจะไม่สามารถสั่งซื้อในช่วงสุดสัปดาห์ได้，สามารถสั่งซื้อได้ตั้งแต่วันจันทร์ถึงวันศุกร์
					if (this.canLocalDelicery) {

						// ตัดสินว่าทั้งวันหรือไม่
						if (!(start_hour == end_hour && start_minute == end_minute)) {

							// เวลาปัจจุบันเร็วกว่าเวลาจัดส่ง，เวลาจัดส่ง：เวลาเริ่มต้น~เวลาสิ้นสุด
							if ((hour < start_hour) || (hour == start_hour && minute < start_minute)) {
								this.orderCreateData.buyer_ask_delivery_time = (start_hour.toString().length == 1 ? "0" + start_hour :
										start_hour) + ':' +
									(start_minute.toString().length == 1 ? "0" + start_minute : start_minute);
							}

							// if (((hour > start_hour && hour < end_hour) || (hour == start_hour && minute > start_minute) || (hour ==
							// 		start_hour && minute >= start_minute && hour < end_hour))) {
							// }

							// เวลาปัจจุบันช้ากว่าเวลาจัดส่ง，เวลาจัดส่งที่ซ่อนอยู่，ไม่สามารถสั่งซื้อได้
							if ((hour > end_hour) || (hour == end_hour && minute > end_minute)) {
								this.canLocalDelicery = false;
							}
						}

					}

				} else {
					this.deliveryWeek = "ร้านค้าไม่ได้เปิดเวลาจัดส่ง";
				}

			}

			Object.assign(this.orderPaymentData, this.orderCreateData);
			this.orderPaymentData.shop_goods_list.goods_list.forEach((v) => {
				if (v.sku_spec_format) {
					console.log(v)
					v.sku_spec_format = JSON.parse(v.sku_spec_format);
				} else {
					v.sku_spec_format = [];
				}
			});
			this.orderCalculate()
		},
		// สตริงเวลาการแปลง
		getTimeStr(val) {
			var h = parseInt(val / 3600).toString();
			var m = parseInt((val % 3600) / 60).toString();
			if (m.length == 1) {
				m = '0' + m;
			}
			if (h.length == 1) {
				h = '0' + h;
			}
			return h + ':' + m;
		},
		clickType(type){
			this.orderCreateData.invoice_type = type;
			this.orderCalculate();
			this.$forceUpdate();
		},
		clickTitleType(type) {
			this.orderCreateData.invoice_title_type = type;
			this.orderCalculate();
			this.$forceUpdate();
		},
		// เลือกเนื้อหาใบแจ้งหนี้
		changeInvoiceContent(invoice_content) {
			this.orderCreateData.invoice_content = invoice_content;
			this.$forceUpdate();
		},
		
		// สลับสวิตช์ใบแจ้งหนี้
		changeIsInvoice() {
			if (this.orderCreateData.is_invoice == 0) {
				this.orderCreateData.is_invoice = 1;
			} else {
				this.orderCreateData.is_invoice = 0;
			}
			this.orderCalculate();
			this.$forceUpdate();
		},
		
		// การตรวจสอบใบแจ้งหนี้
		invoiceVerify() {
			if (!this.orderCreateData.invoice_title) {
				this.$notify({
					message: "กรุณากรอกชื่อใบแจ้งหนี้",
					title: "คำเตือน",type: "warning"
				})
				return false;
			}
			if (!this.orderCreateData.taxpayer_number && this.orderCreateData.invoice_title_type == 2) {
				this.$notify({
					message: "กรุณากรอกเลขประจําตัวผู้เสียภาษีอากร",
					title: "คำเตือน",type: "warning"
				})
				return false;
			}
			if (this.orderCreateData.invoice_type == 1 && !this.orderCreateData.invoice_full_address) {
				this.$notify({
					message: "กรุณากรอกที่อยู่ทางไปรษณีย์ในใบแจ้งหนี้",
					title: "คำเตือน",type: "warning"
				})
				return false;
			}
			if (this.orderCreateData.invoice_type == 2 && !this.orderCreateData.invoice_email) {
				this.$notify({
					message: "กรุณากรอกที่อยู่อีเมลของคุณ",
					title: "คำเตือน",type: "warning"
				})
				return false;
			}
			if (this.orderCreateData.invoice_type == 2) {
				var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
				if (!reg.test(this.orderCreateData.invoice_email)) {
					this.$notify({
						message: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
						title: "คำเตือน",type: "warning"
					})
					return false;
				}
			}
			if (!this.orderCreateData.invoice_content) {
				this.$notify({
					message: "โปรดเลือกเนื้อหาใบแจ้งหนี้",
					title: "คำเตือน",type: "warning"
				})
				return false;
			}
			return true;
		},
		
		/**
		 * การคํานวณคําสั่งซื้อ
		 */
		orderCalculate() {
			this.fullscreenLoading = true
			var data = this.$util.deepClone(this.orderCreateData)
			data.delivery = JSON.stringify(data.delivery)
			data.coupon = JSON.stringify(data.coupon)
			if (this.orderPaymentData.delivery_type == 'store') {
				console.log('store')
				data.member_address = JSON.stringify(this.member_address);
			} else {
				data.member_address = JSON.stringify(data.member_address);
			}
			calculate(data)
				.then(res => {
					const {
						code,
						message,
						data
					} = res
					if (code >= 0) {
						this.orderPaymentData.member_address = res.data.member_address;
						this.orderPaymentData.delivery_money = res.data.delivery_money;
						this.orderPaymentData.coupon_money = res.data.coupon_money;
						this.orderPaymentData.invoice_money = res.data.invoice_money;
						this.orderPaymentData.invoice_delivery_money = res.data.shop_goods_list.invoice_delivery_money;
						this.orderPaymentData.promotion_money = res.data.promotion_money;
						this.orderPaymentData.order_money = res.data.order_money;
						this.orderPaymentData.balance_money = res.data.balance_money;
						this.orderPaymentData.pay_money = res.data.pay_money;
						this.orderPaymentData.goods_money = res.data.goods_money;
						this.orderPaymentData.point_money = res.data.point_money;
						this.orderPaymentData.member_card_money = res.data.member_card_money;
						this.orderPaymentData.shop_goods_list.promotion = res.data.shop_goods_list.promotion;
						this.orderPaymentData.shop_goods_list.coupon_list = res.data.shop_goods_list.coupon_list;
						this.orderPaymentData.shop_goods_list.goods_list = res.data.shop_goods_list.goods_list;
						this.orderPaymentData.shop_goods_list.max_usable_point = res.data.shop_goods_list.max_usable_point;
						// การจัดการพิเศษสําหรับคูปอง
						// if (this.orderPaymentData.shop_goods_list.coupon_list.length == 0) {
						// 	this.orderCreateData.coupon = {};
						// } else if (!this.orderCreateData.coupon.coupon_id) {
						// 	var coupon_list = res.data.shop_goods_list.coupon_list;
						// 	this.orderCreateData.coupon.coupon_id = coupon_list[0].coupon_id;
						// 	this.orderCreateData.coupon.coupon_money = coupon_list[0].money;
						// 	// this.orderCalculate();
						// }

						this.orderPaymentData.shop_goods_list.goods_list.forEach((v) => {

							if (v.sku_spec_format) {
								console.log(v)
								v.sku_spec_format = JSON.parse(v.sku_spec_format);
							} else {
								v.sku_spec_format = [];
							}
						});

					} else {
						this.$notify({
							message: message, //ข้อมูลที่ได้รับแจ้ง
							title: "คำเตือน",type: "warning",
							offset: 225,
							duration: 3000,
							onClose: () => {
								this.$router.go(-1)
								return false
							}
						})
						return
					}
					this.fullscreenLoading = false
				})
				.catch(err => {
					const {
						code,
						message,
						data
					} = err
					this.$notify.error({title: 'Error',message: message});
					this.fullscreenLoading = false
				})
		},

		/**
		 * เลือกวิธีการจัดส่ง
		 */
		/**
		 * เลือกวิธีการจัดส่ง
		 */
		selectDeliveryType(data, siteId, deliveryData) {
			this.tempData = {
				delivery: this.$util.deepClone(this.orderPaymentData.delivery)
			}

			this.siteDelivery.site_id = siteId
			this.siteDelivery.data = deliveryData

			this.orderCreateData.delivery_type = data.name
			this.orderCreateData.delivery_type_name = data.title
			if (data.name == "store") {
				// หากเป็นการจัดส่งที่ร้าน
				// let row = '';
				let that = this;
				data.store_list.forEach(function(e, i) {
					data.store_list[i]["store_address"] = e.full_address + e.address
				})

				this.dialogStore = true
				this.storeList = data.store_list
				this.orderPaymentData.delivery.delivery_type = 'store'
				this.orderPaymentData.delivery.delivery_type_name = 'เก็บรถกระบะ'
				Object.assign(this.orderPaymentData, this.orderCreateData)
				if (this.orderPaymentData.delivery.store_id) {
					this.orderCalculate()
				}else{
					this.orderPaymentData.delivery.store_id = 0;
				}

			} else if (data.name == "local") {
				this.deliveryTime = true
				this.time = this.orderCreateData.delivery[siteId].buyer_ask_delivery_time;
			} else {
				console.log(this.orderPaymentData, 'orderPaymentData')
				this.orderPaymentData.delivery.delivery_type = 'express'
				this.orderPaymentData.delivery.delivery_type_name = 'การจัดส่งโลจิสติกส์'
				Object.assign(this.orderPaymentData, this.orderCreateData)
				console.log(this.orderPaymentData, 'this.orderPaymentData')
				this.orderCalculate()
			}
			this.$forceUpdate()
		},

		/**
		 * ตั้งค่าจุดเบิกสินค้าที่เลือก
		 * @param {Object} item
		 */
		setStore(row) {
			this.$refs.singleTable.setCurrentRow(row)
		},

		/**
		 * เลือกจุดรับสินค้า
		 * @param {Object} item
		 */
		selectStore(item) {
			if (!item) return;
			let store_id = item.store_id
			this.dialogStore = false
			this.orderCreateData.delivery.store_id = store_id
			this.orderCreateData.delivery.delivery_type = this.orderCreateData.delivery_type
			this.orderCreateData.delivery.store_name = item.store_name
			Object.assign(this.orderPaymentData, this.orderCreateData)
			this.storeRadio = item
			this.orderCalculate()
			this.$forceUpdate()
		},

		/**
		 * แสดงข้อมูลคูปอง
		 * @param {Object} siteId
		 * @param {Object} couponData
		 */
		openPlatformCoupon() {
			let row = 0
			let that = this;
			this.dialogPlatcoupon = true
			this.orderPaymentData.shop_goods_list.coupon_list.forEach(function(e, i) {
				if (e.coupon_id == that.orderPaymentData.coupon.coupon_id) {
					row = e
					console.log(e)
				}
			})

			setTimeout(function() {
				that.setPlatformCurrent(row)
				that.platformCouponRadio = row;
			}, 50)
		},

		/**
		 * ยกเลิกการเลือกคูปอง
		 * @param {Object} item
		 */
		setPlatformCurrent(row) {
			this.$refs.platformCouponTable.setCurrentRow(row)
			if (row == undefined) {
				console.log('ยกเลิก')
				this.orderCalculate()
			}
		},
		/**
		 * ยืนยันการเลือกคูปอง
		 * @param {Object} item
		 */
		savePlatformCoupon() {
			this.dialogPlatcoupon = false
			console.log('ยืนยัน')
			this.orderCalculate()
		},

		/**
		 * เลือกคูปอง
		 * @param {Object} item
		 */
		selectPlatformCoupon(item) {
			if (this.orderCreateData.coupon.coupon_id != item.coupon_id) {
				this.orderCreateData.coupon.coupon_id = item.coupon_id;
				this.orderCreateData.coupon.coupon_money = item.money;
				this.platformCouponRadio = item;
			} else {
				this.orderCreateData.coupon.coupon_id = 0;
				this.orderCreateData.coupon.coupon_money = '0.00';
				this.platformCouponRadio = '';
			}
			Object.assign(this.orderPaymentData, this.orderCreateData);
			console.log(this.orderPaymentData.coupon, 'this.orderCreateData.coupon')
			this.$forceUpdate()

		},

		/**
		 * แสดงข้อมูลคูปองร้านค้า
		 * @param {Object} siteId
		 * @param {Object} couponData
		 */
		// openSiteCoupon(siteId, couponData) {
		// 	this.tempData = {
		// 		coupon: this.$util.deepClone(this.orderPaymentData.coupon)
		// 	}
		// 	let row = 0
		// 	let that = this
		// 	this.siteCoupon.site_id = siteId
		// 	couponData.forEach(function(e, i) {
		// 		if (e.at_least > 0) {
		// 			couponData[i]["use"] = "เต็ม" + e.at_least + "มีอยู่"
		// 		} else {
		// 			couponData[i]["use"] = "จํานวนเงินใด ๆ สามารถใช้ได้"
		// 		}
		// 		couponData[i]["time"] = timeStampTurnTime(e.end_time)

		// 		if (e.coupon_id == that.orderCreateData.coupon[that.siteCoupon.site_id].coupon_id) {
		// 			row = e
		// 		}
		// 	})
		// 	this.siteCoupon.data = couponData
		// 	this.dialogCoupon = true

		// 	setTimeout(function() {
		// 		that.setCurrent(row)
		// 		that.couponRadio = row;
		// 	}, 50)
		// },
		/**
		 * เลือกคูปอง
		 * @param {Object} item
		 */
		selectCoupon(item) {
			if (!item) {
				this.orderCreateData.coupon[this.siteCoupon.site_id].coupon_id = 0
				this.orderCreateData.coupon[this.siteCoupon.site_id].coupon_money = "0.00"
				this.couponRadio = '';
			} else {
				if (this.orderCreateData.coupon[this.siteCoupon.site_id].coupon_id != item.coupon_id) {
					this.orderCreateData.coupon[this.siteCoupon.site_id].coupon_id = item.coupon_id
					this.orderCreateData.coupon[this.siteCoupon.site_id].coupon_money = item.money
					this.couponRadio = item;
				} else {
					this.couponRadio = '';
					this.orderCreateData.coupon[this.siteCoupon.site_id].coupon_id = 0
					this.orderCreateData.coupon[this.siteCoupon.site_id].coupon_money = "0.00"
				}
			}
			Object.assign(this.orderPaymentData, this.orderCreateData)

			this.$forceUpdate()
		},

		/**
		 * ยกเลิกการเลือกคูปอง
		 * @param {Object} item
		 */
		setCurrent(row) {
			this.$refs.couponTable.setCurrentRow(row)
			if (row == undefined) {
				this.orderCalculate()
			}
		},
		/**
		 * ยืนยันการเลือกคูปอง
		 * @param {Object} item
		 */
		saveCoupon() {
			this.dialogCoupon = false
			this.orderCalculate()
		},

		/**
		 * แสดงข้อเสนอร้านค้า
		 * @param {Object} data
		 */
		openSitePromotion(data) {
			this.sitePromotion = data
			if (this.promotionInfo) {
				this.promotionInfo = false
			} else {
				this.promotionInfo = true
			}
		},

		/**
		 * ใช้ยอดเงินคงเหลือหรือไม่
		 */
		useBalance(type) {
			if (this.orderCreateData.is_balance) this.orderCreateData.is_balance = 0
			else this.orderCreateData.is_balance = 1
			this.orderCalculate()
			this.$forceUpdate()
		},

		// ใช้คะแนน
		usePoint(type) {
			if (this.orderCreateData.is_point) this.orderCreateData.is_point = 0;
			else this.orderCreateData.is_point = 1;
			this.orderCalculate();
			this.$forceUpdate();
		},

		orderCreate() {
			if (this.verify()) {
				if (this.isSub) return
				if(this.orderCreateData.is_invoice == 1){
					if(this.invoiceVerify() === false) return;
				}
		
				this.isSub = true

				var loading = this.$loading({
					lock: true,
					text: "การส่งคําสั่งซื้อ...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)"
				})
				var data = this.$util.deepClone(this.orderCreateData);
				data.delivery = JSON.stringify(data.delivery);
				data.coupon = JSON.stringify(data.coupon);
				if (this.orderCreateData.delivery.delivery_type == 'store') {
					data.member_address = JSON.stringify(this.member_address);
				} else {
					data.member_address = JSON.stringify(data.member_address);
				}
				orderCreate(data)
					.then(res => {
						const {
							code,
							message,
							data
						} = res
						loading.close()
						if (code >= 0) {
							this.$store.dispatch("order/removeOrderCreateData", "")
							if (this.orderPaymentData.pay_money == 0) {
								this.$router.push({
									path: "/result",
									query: {
										code: data
									}
								})
							} else {
								this.$router.push({
									path: "/pay",
									query: {
										code: data
									}
								})
							}
						} else {
							this.$notify({
								message: message,
								title: "คำเตือน",type: "warning"
							})
						}
					})
					.catch(err => {
						loading.close()
						this.isSub = false
						const {
							code,
							message,
							data
						} = err
						this.$notify.error({title: 'Error',message: message});
					})
			}
		},
		/**
		 * การยืนยันคําสั่งซื้อ
		 */
		verify() {
			if (this.orderPaymentData.is_virtual == 1) {
				if (!this.orderCreateData.member_address.mobile.length) {
					this.$notify({
						message: "กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ",
						title: "คำเตือน",type: "warning"
					})
					return false
				}
				var reg = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/
				if (!reg.test(this.orderCreateData.member_address.mobile)) {
					this.$notify({
						message: "โปรดป้อนหมายเลขโทรศัพท์มือถือที่ถูกต้อง",
						title: "คำเตือน",type: "warning"
					})
					return false
				}
			}

			if (this.orderPaymentData.is_virtual == 0) {
				if (!this.orderPaymentData.member_address) {
					this.$notify({
						message: "โปรดเลือกที่อยู่จัดส่งของคุณก่อน",
						title: "คำเตือน",type: "warning"
					})

					return false
				}

				let deliveryVerify = true

				for (let key in this.orderCreateData.delivery) {
					if (JSON.stringify(this.orderCreateData.delivery[key]) == "{}") {
						deliveryVerify = false
						this.$notify({
							message: 'ร้าน"' + this.orderPaymentData.shop_goods_list[key].site_name + '"ไม่มีการตั้งค่าวิธีการจัดส่ง',
							title: "คำเตือน",type: "warning"
						})

						break
					}
					if (this.orderCreateData.delivery[key].delivery_type == "store" && this.orderCreateData.store_id ==
						0) {
						deliveryVerify = false
						this.$notify({
							message: 'ร้าน"' + this.orderPaymentData.shop_goods_list[key].site_name + '"ไม่มีร้านค้าให้มารับ,โปรดเลือกวิธีการจัดส่งอื่น',
							title: "คำเตือน",type: "warning"
						})

						break
					}
				}
				if (!deliveryVerify) return false
			}
			if (this.orderPaymentData.delivery_type == 'store') {
				if (JSON.stringify(this.orderPaymentData.delivery) == "{}") {
					this.$notify({
						message: 'โปรดเลือกร้านรับสินค้า',
						title: "คำเตือน",type: "warning"
					})
					return false
				}
			}
			// if (this.orderCreateData.is_balance == 1 && this.orderCreateData.pay_password == "") {

			// 	this.dialogpay = true
			// 	return false
			// }
			return true
		},
		/**
		 * ป้อนรหัสผ่านการชําระเงิน
		 */
		input() {
			if (this.password.length == 6) {
				var loading = this.$loading({
					lock: true,
					text: "การจ่ายเงิน",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)"
				})

				checkpaypassword({
						pay_password: this.password
					})
					.then(res => {
						const {
							code,
							message,
							data
						} = res
						loading.close()
						if (code >= 0) {
							this.orderCreateData.pay_password = this.password
							this.orderCreate()
							this.dialogpay = false
						} else {
							this.$notify({
								message: message,
								title: "คำเตือน",type: "warning"
							})
						}
					})
					.catch(err => {
						loading.close()
						const {
							code,
							message,
							data
						} = err
						this.$notify.error({title: 'Error',message: message});
					})
			}
		},

		textarea() {
			this.$forceUpdate()
		},
		bindTimeChange(time) {
			this.time = time
		},
		setDeliveryTime(site_id) {
			this.deliveryTime = false
			this.orderCreateData.delivery[site_id].buyer_ask_delivery_time = this.time;
		},
		imageError(index) {
			this.orderPaymentData.shop_goods_list.goods_list[index].sku_image = this.defaultGoodsImage
		},
		setPayPassword() {
			this.$router.pushToTab("/member/security");
		}

	}
}
